import { createI18n } from 'vue-i18n';

import en from './i18n/en.json';
import fr from './i18n/fr.json';
import nl from './i18n/nl.json';

import nxtStylesEn from '@nxtpeople/nxt-styles/dist/translations/en.json';
import nxtStylesFr from '@nxtpeople/nxt-styles/dist/translations/fr.json';
import nxtStylesNl from '@nxtpeople/nxt-styles/dist/translations/nl.json';

const userAgentLocale = window.navigator.language.substring(0, 2);
const savedLocale = window.localStorage.getItem('locale');
const locale = savedLocale || userAgentLocale || 'en';

export default createI18n({
   legacy: false,
   locale,
   fallbackLocale: 'en',
   messages: { nl: { ...nl, ...nxtStylesNl }, en: { ...en, ...nxtStylesEn }, fr: { ...fr, ...nxtStylesFr } },
   globalInjection: true,
   warnHtmlInMessage: 'warn',
});
